import { Box } from '@mui/material'
import { Loading } from 'components/ui'
import { useFamily, useUser } from 'hooks'
import { useGeolocation } from 'hooks/use-geolocation'
import { Paper } from 'oneui'
import useCountriesQuery from 'queries/use-countries-query'
import { SummaryPaperStyle } from 'styles/theme/theme'

import ProfileCard from './profile-card'
import SmallProfileCard from './small-profile-card'
import FamilySummary from '../../family/family-summary'

export type ProfileCardProps = {
  loginId: string
  familyName: string
  givenName: string
  photoUrl: string
  statusMessage: string
  isShowBadge: boolean
}

function ProfileSummary() {
  const { user, isInitializing: isUserInitializing } = useUser(true)
  const { family, isInitializing: isFamilyInitializing } = useFamily(true)
  const { geolocation, isAlertEnabled, isInitializing: isGeoInitializing } = useGeolocation(false)
  const { data: countriesData, isError: isPolicyError } = useCountriesQuery()

  const isFamilySupportedCountry = !isPolicyError
    ? countriesData?.countries?.[user.countryCode]?.childAccount?.childAccountSupported ?? false
    : false

  const accountDisplayPriority = { email: 0, phone: 1 }
  const activeAccounts = user.accounts
    .filter((account) => 'NORMAL' === account.status)
    .sort((a, b) => accountDisplayPriority[a.type] - accountDisplayPriority[b.type])

  const isBadgeNeed = (): boolean => {
    return !isGeoInitializing && isAlertEnabled && user.countryCode !== 'CN' && user.countryCode !== geolocation
  }

  const profileCardProps: ProfileCardProps = {
    loginId: activeAccounts[0]?.value,
    familyName: user.lastName,
    givenName: user.firstName,
    photoUrl: user.photoUrl,
    statusMessage: user.statusMessage,
    isShowBadge: isBadgeNeed()
  }

  return (
    <div>
      {isUserInitializing || isFamilyInitializing || isGeoInitializing ? (
        <Paper
          sx={{
            ...SummaryPaperStyle,
            height: { xs: 'auto', md: '400px' },
            minHeight: '320px',
            padding: { xs: '10px 30px', md: '10px 40px' },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Loading />
          </Box>
        </Paper>
      ) : isFamilySupportedCountry && family.memberCount > 0 ? (
        <Box sx={{ height: { xs: '390px', md: '400px' } }}>
          <SmallProfileCard profile={profileCardProps} />
          <FamilySummary familyGroup={family} />
        </Box>
      ) : (
        <ProfileCard profile={profileCardProps} />
      )}
    </div>
  )
}

export default ProfileSummary
